// Utility functions for parsing and sorting download filenames

export function parseFilename(filename: string) {
  const match = filename.match(/^(\d{4}-\d{2}-\d{2}T\d{2}-\d{2}-\d{2})_batch(\d+)\.zip$/)
  if (match) {
    return {
      date: match[1],
      batch: parseInt(match[2], 10)
    }
  }
  // Fallback for files that don't match expected format
  return { date: filename, batch: 0 }
}

export function sortFiles(a: string, b: string) {
  const fileA = parseFilename(a)
  const fileB = parseFilename(b)

  // First sort by date
  if (fileA.date !== fileB.date) {
    return fileA.date.localeCompare(fileB.date)
  }

  // Then sort by batch number
  return fileA.batch - fileB.batch
} 